"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanName = exports.containsWebsite = exports.hexColorValidationRegex = exports.companyNamePostgreSQLPattern = exports.namePostgreSQLPattern = exports.companyNameValidationRegex = exports.nameValidationRegex = exports.blockedCharsInNames = exports.blockedCharsInCompanyNames = void 0;
exports.createPostgreSQLValidationPattern = createPostgreSQLValidationPattern;
exports.blockedCharsInCompanyNames = `@#$%*+=|/<>\\[\\]{}:;"~!?^_\\\\`;
exports.blockedCharsInNames = `${exports.blockedCharsInCompanyNames}()0-9`;
/**
 * Creates a validation regex pattern that blocks problematic special characters
 * while allowing international characters and common punctuation.
 *
 * @param additionalBlockedChars - Additional blocked characters (e.g., '&,()', etc.)
 * @returns RegExp for validation
 */
function createValidationRegex(blockedCharacters) {
    return new RegExp(`^[^${blockedCharacters}]*$`);
}
exports.nameValidationRegex = createValidationRegex(exports.blockedCharsInNames);
exports.companyNameValidationRegex = createValidationRegex(exports.blockedCharsInCompanyNames);
/**
 * Creates PostgreSQL-compatible regex validation pattern for database operations
 * @param additionalBlockedChars - Additional blocked characters (e.g., '&,()', etc.)
 * @returns PostgreSQL regex validation pattern string
 */
function createPostgreSQLValidationPattern(rawBlockedCharacters) {
    const chars = [...rawBlockedCharacters];
    const escaped = chars
        .map((char) => {
        //escape mandatory to be able tu use this expression in the entity (with E) that will be then correctly formatted from TS migration to SQL pattern
        if (char === "\\") {
            return "\\\\\\\\";
        }
        return char;
    })
        .join("");
    return `^[^${escaped}]*$`;
}
exports.namePostgreSQLPattern = createPostgreSQLValidationPattern(exports.blockedCharsInNames);
exports.companyNamePostgreSQLPattern = createPostgreSQLValidationPattern(exports.blockedCharsInCompanyNames);
exports.hexColorValidationRegex = /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{4}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/;
const websiteTopLevelDomains = [
    "com",
    "org",
    "net",
    "info",
    "biz",
    "edu",
    "gov",
    "io",
    "ai",
    "app",
    "dev",
    "xyz",
    "online",
    "site",
    "website",
    "store",
    "shop",
    "club",
    "live",
    "life",
    "world",
    "tv",
    "media",
    "blog",
    "link",
    "space",
    "studio",
    "tech",
    "ca",
    "us",
    "uk",
    "fr",
    "ie",
    "nl",
    "eu",
    "au",
    "nz",
    "me",
    "co",
];
const websiteValidationRegex = new RegExp(`(?:https?://|www[0-9]?\\.|[a-z0-9][a-z0-9-]+\\.(?:${websiteTopLevelDomains.join("|")})\\b)`, "i");
const obfuscatedDotRegex = /\s*[([{]\s*dot\s*[)\]}]\s*/gi;
const containsWebsite = (value) => {
    if (!value) {
        return false;
    }
    return websiteValidationRegex.test(value.replace(obfuscatedDotRegex, "."));
};
exports.containsWebsite = containsWebsite;
// Pre-compiled regex for cleanName, derived from blockedCharsInNames
// .replace() escapes \ ] ^ which are special chars in regex character classes
const blockedCharsRegex = new RegExp(`[${exports.blockedCharsInNames.replace(/[\\\]^]/g, "\\$&")}]+`, "g");
/**
 * Removes invalid characters from a name field (firstName, lastName) based on blockedCharsInNames rule.
 * Invalid characters are replaced with a single space to preserve word boundaries.
 * Returns undefined if the result is empty after cleaning.
 */
const cleanName = (name) => {
    if (!name) {
        return undefined;
    }
    const cleaned = name.replace(blockedCharsRegex, " ").replace(/\s+/g, " ").trim();
    return cleaned || undefined;
};
exports.cleanName = cleanName;
